<script setup lang="ts">
    import { EchoFilterCheckbox } from '@/js/services/api/filter/types';
    import RemovableActiveFilter from './RemovableActiveFilter.vue';
    import { __untypedExpression } from '@/js/stores/expressions';

    const props = withDefaults(
        defineProps<{
            filter?: EchoFilterCheckbox[];
            checkboxes?: EchoFilterCheckbox[];
            iconBase?: string;
            removable?: boolean;
            expressionBase?: string;
        }>(),
        {
            filter: undefined,
            checkboxes: undefined,
            iconBase: undefined,
            removable: true,
            expressionBase: undefined,
        }
    );

    const removeSelectedCheckbox = (filter: EchoFilterCheckbox[], item: EchoFilterCheckbox) => {
        if (!props.removable) {
            return;
        }

        for (let checkbox of filter) {
            if (checkbox.id === item.id) {
                const element = document.querySelector(
                    'input[type="checkbox"][data-name="' +
                        checkbox.name +
                        '"][value="' +
                        checkbox.id +
                        '"]'
                ) as HTMLInputElement | null;

                if (element) {
                    element.checked = false;
                    element.dispatchEvent(new Event('change'));
                } else {
                    checkbox.isSelected = false;
                }

                return;
            }

            if (checkbox.children && checkbox.children.length > 0) {
                removeSelectedCheckbox(checkbox.children, item);
            }
        }
    };

    const itemIcon = (item: EchoFilterCheckbox) => {
        if (!props.removable) {
            return undefined;
        }

        return props.iconBase ? `${props.iconBase}-${item.name.toLowerCase()}.svg` : undefined;
    };
</script>

<template>
    <template v-if="props.filter && props.checkboxes">
        <li v-for="item in props.checkboxes" :key="String(item.id)">
            <RemovableActiveFilter
                :icon="itemIcon(item)"
                :removable="props.removable"
                @remove-filter="removeSelectedCheckbox(props.filter, item)"
            >
                {{
                    props.expressionBase
                        ? __untypedExpression(
                              props.expressionBase + item.name.toLowerCase().replaceAll(' ', '-')
                          )
                        : item.name
                }}
            </RemovableActiveFilter>
        </li>
    </template>
</template>
